import { ReactNode } from 'react';
import { Checkbox as AriaCheckbox } from 'react-aria-components';
import type { CheckboxProps as AriaCheckboxProps } from 'react-aria-components';



interface CheckboxProps extends Omit<AriaCheckboxProps, 'children'> {
	children?: ReactNode;
}


export function Checkbox(props: CheckboxProps) {
	const { isIndeterminate, children, ...otherProps } = props;

	return (
		<AriaCheckbox {...otherProps} isIndeterminate={isIndeterminate ? true : false}>
			
			<div className="checkbox">
				<svg viewBox="0 0 18 18" aria-hidden="true">
					{isIndeterminate
						? <rect x={1} y={7.5} width={15} height={3} />
						: <polyline points="1 9 7 14 15 4" />
					}
				</svg>
			</div>
		
			{children}
		
		</AriaCheckbox>
	)
}